<!-- 
	This is the dashboard layout, used in dashboard, tables, billing and profile pages.
 -->

<template>
	<div>
		<!--  :class="{'lock-UI' : showBoxChat}" Dashboard Layout layout-dashboard -->
		<a-layout  v-if="loadingSidebar" class="layout-dashboard" id="components-layout-demo-responsive"
			:class="[navbarFixed ? 'navbar-fixed' : '', !sidebarCollapsed ? 'has-sidebar' : '', layoutClass]">

			<!-- <div v-if="loadingSidebar"></div> -->

			<!-- Main Sidebar -->
			<DashboardSidebar 
					:sidebarCollapsed="sidebarCollapsed" :sidebarColor="sidebarColor"
					:sidebarTheme="sidebarTheme" @toggleSidebar="toggleSidebar"></DashboardSidebar>
				<!-- / Main Sidebar -->

				<!-- Layout Content -->
				<a-layout>

					<!-- Layout Header's Conditionally Fixed Wrapper -->
					<DashboardHeader :sidebarCollapsed="sidebarCollapsed" :navbarFixed="navbarFixed"
						@toggleSettingsDrawer="toggleSettingsDrawer" @toggleSidebar="toggleSidebar"></DashboardHeader>
					<!-- / Layout Header's Conditionally Fixed Wrapper -->

					<!-- Page Content -->
					<a-layout-content class="mb-50">
						<router-view />
					</a-layout-content>
					<!-- / Page Content -->

					<!-- Layout Footer -->
					<DashboardFooter></DashboardFooter>
					<!-- / Layout Footer -->

					<!-- Floating Action Button For Toggling Settings Drawer -->
					<!-- Width: {{ window.width }} px -->
					<!--  
						<div v-if="showBoxChat" class="main-chat-ui-ai">
							<div class="chat-ui-ai-title" style="">
								<a-list>
									<a-list-item>
										<a-list-item-meta>
											<div slot="title">
												<h4 class="mt-0 mb-0 font-web" >ChatBot AI</h4>
											</div>
											<div slot="description">
												<span class="font-web text-muted text-sm">*** บทสนทนาของท่านจะถูกเก็บเป็นความลับ และข้อมูลจะไม่ถูกนำไปใช้งานต่อ ***</span>
											</div>
											<a-avatar
												slot="avatar"
												icon="reddit"
											/>
										</a-list-item-meta>
										<div>
											<a-button @click="showBoxChat = !showBoxChat" size="small" type="danger" shape="circle" icon="close" />
										</div>
									</a-list-item>
								</a-list>
							</div>
							<div class="chat-ui-ai-massage mb-20">
								<ListMassage></ListMassage>
							</div>
							<div class="chat-ui-ai-boxtext">
								<BoxTextMassage></BoxTextMassage>
								<div v-if="window.width >= 1900">
									<a-button class="mr-5" size="small" closable v-model="checked1" @change="handleChange">
										Tag1
									</a-button>
									<a-button class="mr-5" size="small" v-model="checked2" @change="handleChange">
										Tag2
									</a-button>
									<a-button class="mr-5" size="small" v-model="checked3" @change="handleChange">
										Tag3
									</a-button>
								</div>
							</div>
						</div>
					-->
					<!--  
						<a-button v-if="!showBoxChat" @click="showBoxChat = !showBoxChat" size="large" class="fab-ai-btn" >
							<a-icon style="color: #433878;" type="reddit" class="mr-10" /> Assistant 
						</a-button> 
					-->
					<!-- / Floating Action Button For Toggling Settings Drawer -->

					<!-- Sidebar Overlay -->
					<!-- <div class="sidebar-overlay" @click="sidebarCollapsed = true" v-show="!sidebarCollapsed"></div> -->
					<!-- / Sidebar Overlay -->

				</a-layout>
				<!-- / Layout Content -->

				<!-- Settings Drawer -->
					<!-- 
						<DashboardSettingsDrawer
							:showSettingsDrawer="showSettingsDrawer"
							:navbarFixed="navbarFixed"
							:sidebarTheme="sidebarTheme"
							@toggleSettingsDrawer="toggleSettingsDrawer"
							@toggleNavbarPosition="toggleNavbarPosition"
							@updateSidebarTheme="updateSidebarTheme"
							@updateSidebarColor="updateSidebarColor"
						></DashboardSettingsDrawer>
					-->
				<!-- / Settings Drawer -->

			<!--  
				<div class="my-50" v-else>
					<div class="text-center mb-10">
						<img style="width 30px;height: 70px;" src="../../public/images/muiclogoOf.png" alt="" />
						<p class="mt-20 mb-0 font-web"><a-spin class="mr-20" />Welcome to MY MUIC ...</p>
					</div>
				</div>
			-->

		</a-layout>
		<!-- / Dashboard Layout -->

	</div>
</template>

<script>

import DashboardSidebar from '../components/Sidebars/DashboardSidebar';
import DashboardHeader from '../components/Headers/DashboardHeader';
import DashboardFooter from '../components/Footers/DashboardFooter';
import DashboardSettingsDrawer from '../components/Sidebars/DashboardSettingsDrawer';
// ai component

// import ListMassage from './ChatAi/ListMassage.vue';
// import BoxTextMassage from './ChatAi/BoxTextMassage.vue';

export default ({
	components: {
		DashboardSidebar,
		DashboardHeader,
		DashboardFooter,
		DashboardSettingsDrawer,
		// ListMassage,
		// BoxTextMassage
	},
	data() {
		return {
			// Sidebar collapsed status.
			sidebarCollapsed: false,

			// Main sidebar color.
			sidebarColor: "primary",

			// Main sidebar theme : light, white, dark.
			sidebarTheme: "light",

			// Header fixed status.
			navbarFixed: false,

			// Settings drawer visiblility status.
			showSettingsDrawer: false,

			// Main sidebar : loading
			loadingSidebar: false,

			// Box ai Chat
			showBoxChat: false,

			window: {
				width: 0,
				height: 0
			},
			checked1: true,
			checked2: true,
			checked3: true,
		}
	},
	created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
	mounted() {
		setTimeout(() => {
			this.loadingSidebar = true;
		}, 1000);
	},
	destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
	methods: {
		handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
		handleChange(checked) {
			console.log(checked);
		},
		toggleSidebar(value) {
			this.sidebarCollapsed = value;
		},
		toggleSettingsDrawer(value) {
			this.showSettingsDrawer = value;
		},
		toggleNavbarPosition(value) {
			this.navbarFixed = value;
		},
		updateSidebarTheme(value) {
			this.sidebarTheme = value;
		},
		updateSidebarColor(value) {
			this.sidebarColor = value;
		},
	},
	computed: {
		// Sets layout's element's class based on route's meta data.
		layoutClass() {
			return this.$route.meta.layoutClass;
		}
	},
})

</script>


<style scoped>
	#components-a-popconfirm-demo-placement .ant-btn {
		width: 700px;
		text-align: center;
		padding: 0;
		margin-right: 8px;
		margin-bottom: 8px;
	}
</style>